import React from "react";
import team1 from "../../assets/images/sponsors/1.png";
import team10 from "../../assets/images/sponsors/10.png";
import team11 from "../../assets/images/sponsors/11.png";
import team12 from "../../assets/images/sponsors/12.png";
import team13 from "../../assets/images/sponsors/13.png";
import team14 from "../../assets/images/sponsors/14.png";
import team15 from "../../assets/images/sponsors/15.png";
import team16 from "../../assets/images/sponsors/16.png";
import team17 from "../../assets/images/sponsors/17.png";
import team18 from "../../assets/images/sponsors/18.png";
import team19 from "../../assets/images/sponsors/19.png";
import team2 from "../../assets/images/sponsors/2.png";
import team20 from "../../assets/images/sponsors/20.png";
import team21 from "../../assets/images/sponsors/21.png";
import team22 from "../../assets/images/sponsors/22.png";
import team23 from "../../assets/images/sponsors/23.png";
import team24 from "../../assets/images/sponsors/24.png";
import team25 from "../../assets/images/sponsors/25.png";
import team26 from "../../assets/images/sponsors/26.png";
import team3 from "../../assets/images/sponsors/3.png";
import team4 from "../../assets/images/sponsors/4.png";
import team5 from "../../assets/images/sponsors/5.png";
import team6 from "../../assets/images/sponsors/6.png";
import team7 from "../../assets/images/sponsors/7.png";
import team8 from "../../assets/images/sponsors/8.png";
import team9 from "../../assets/images/sponsors/9.png";

function TeamHomeOne({ className }) {
  return (
    <>
      <section className={`appie-team-area pt-100 pb-100 ${className || ""}`}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="appie-section-title text-center">
                <h3 className="appie-title">Meet Our Sponsors</h3>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="200ms">
                <div className="thumb">
                  <img
                    src={team1}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Title Sponsor</h5>
                  <strong>Ranawat Group</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="400ms">
                <div className="thumb">
                  <img
                    src={team2}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Cricket Sponsor</h5>
                  <strong>Makwana & Tanmay Construction</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="600ms">
                <div className="thumb">
                  <img
                    src={team3}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Football Sponsor</h5>
                  <strong>Onyx Realty</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="800ms">
                <div className="thumb">
                  <img
                    src={team4}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Badminton Sponsor</h5>
                  <strong>Study Smart</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="200ms">
                <div className="thumb">
                  <img
                    src={team5}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Jersey Sponsor</h5>
                  <strong>Siddhivinayak Groups</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="400ms">
                <div className="thumb">
                  <img
                    src={team6}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Trophy Sponsor</h5>
                  <strong>BJB Group</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="600ms">
                <div className="thumb">
                  <img
                    src={team7}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Kitbag Sponsor</h5>
                  <strong>JBN Pune</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="800ms">
                <div className="thumb">
                  <img
                    src={team8}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Basketball Sponsor</h5>
                  <strong>SJ Loans</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="200ms">
                <div className="thumb">
                  <img
                    src={team9}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Volleyball Sponsor</h5>
                  <strong>Praneet Investment Solutions</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="400ms">
                <div className="thumb">
                  <img
                    src={team10}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Table Tennis Sponsor</h5>
                  <strong>Sukanta</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="600ms">
                <div className="thumb">
                  <img
                    src={team11}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Swimming Sponsor</h5>
                  <strong>Siddhi Group</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="800ms">
                <div className="thumb">
                  <img
                    src={team12}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Snooker Sponsor</h5>
                  <strong>Break the Snook</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="200ms">
                <div className="thumb">
                  <img
                    src={team13}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Hospitality Partner</h5>
                  <strong>Pending</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="400ms">
                <div className="thumb">
                  <img
                    src={team14}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Officials Partner</h5>
                  <strong>Suraj Info</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="600ms">
                <div className="thumb">
                  <img
                    src={team15}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Tech Partner</h5>
                  <strong>Dreams International</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="800ms">
                <div className="thumb">
                  <img
                    src={team16}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Venue Partner</h5>
                  <strong>Flame University</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="200ms">
                <div className="thumb">
                  <img
                    src={team17}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Media Partner</h5>
                  <strong>Mukund Thakkar Productions</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="400ms">
                <div className="thumb">
                  <img
                    src={team18}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Branding Partner</h5>
                  <strong>Visionary Signs</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="600ms">
                <div className="thumb">
                  <img
                    src={team19}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Sports Equipments Partner</h5>
                  <strong>Maharashtra Sports</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="800ms">
                <div className="thumb">
                  <img
                    src={team20}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Medical Partner</h5>
                  <strong>Sancheti Hospital</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="200ms">
                <div className="thumb">
                  <img
                    src={team21}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Energy Drink Partner</h5>
                  <strong>Hurricane Energy Drink</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="400ms">
                <div className="thumb">
                  <img
                    src={team22}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Munching Partner</h5>
                  <strong>Cornitos</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="600ms">
                <div className="thumb">
                  <img
                    src={team23}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Event Partner</h5>
                  <strong>Raka Decorators & Events</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="800ms">
                <div className="thumb">
                  <img
                    src={team24}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Grooming Partner</h5>
                  <strong>Adikara Organics</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="200ms">
                <div className="thumb">
                  <img
                    src={team25}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Club Sponsor</h5>
                  <strong>Koncept Electrci Zone</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div
                className="appie-team-item mt-30 wow animated fadeInUp"
                data-wow-duration="2000ms"
                data-wow-delay="400ms">
                <div className="thumb">
                  <img
                    src={team26}
                    alt=""
                  />
                </div>
                <div className="content text-center">
                  <h5 className="title">Gala Night Sponsor</h5>
                  <strong>Elegance by Sanjay Jaju</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TeamHomeOne;
